import * as StaticAssets from "./StaticAssets";

export type TableauLocalizedStrings = {
  getString(key: string): string;

  // Functions that interpolate arguments into localized strings
  AuthoringWorkbookTitle(workbookName: string): string;
  EmbeddedWorkbookTitle(workbookName: string): string;
  ErrorPageHelpOnline(communityLink: string): string;
  MaintenanceMessage(serverName: string): string;
  PublicErrorBrowseGallery(link: string): string;
  InstantAnalyticsGenericExceptionMessage(dataProvider: string): string;
};

type TableauNamespace = { Strings: TableauLocalizedStrings };
type TableauWindow = Window & typeof globalThis & { tab: TableauNamespace };

export function loadStrings(
  doc: Document,
  languageLocale: Intl.Locale
): Promise<TableauLocalizedStrings> {
  const strings = (window as TableauWindow)?.tab?.Strings;
  return strings
    ? Promise.resolve(strings)
    : StaticAssets.loadLocalizedStrings(doc, languageLocale).then(
        () => (window as TableauWindow).tab.Strings
      );
}
